import {MarketingBlockData} from "../types/base-marketing-block-types";

export const defaultMarketingBlockData: MarketingBlockData = {
  id: 0,
  title: '',
  comment: '',
  history: []
}
